import { CurrentUserService } from './../services/authentication/current-user.service';
/* eslint-disable @typescript-eslint/no-explicit-any */
import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpInterceptorFn } from '@angular/common/http';
import { Observable, catchError, throwError } from 'rxjs';

import { HttpApiError } from '../constants/httpapierror';
import { JwtHelperService } from '@auth0/angular-jwt';
import { SessionStorageService } from '../services/session-storage.service';
import { ToastService } from '../services/toast.service';
import { environment } from '../../../environments/environment';

export const errorInterceptor: HttpInterceptorFn = (request, next): Observable<HttpEvent<any>> => {
  const currentUser = inject(CurrentUserService);
  const toast = inject(ToastService);
  const sessionService = inject(SessionStorageService);
  const jwtHelper = inject(JwtHelperService);
  const getJWTToken = () => {
    const token = sessionService.get('token');
    if (token !== null) {
      return token;
    }
    return '';
  };
  const handleError = (err: any): Observable<never> => {
    if (err instanceof HttpErrorResponse) {
      const token = getJWTToken();

      if (
        !token &&
        !jwtHelper.isTokenExpired(token) &&
        (err.status === HttpApiError.UnknownError ||
          err.status === HttpApiError.Forbidden ||
          err.status === HttpApiError.NotFound ||
          err.status === HttpApiError.TimeOut ||
          err.status === HttpApiError.Unauthorized)
      ) {
        toast.openErrorToast(
          'Server cannot process the request. Please try again later',
          '',
          environment.TOAST_DELAY,
        );

        currentUser.logout.next(false);
      }
    }
    return throwError(() => err);
  };
  return next(request).pipe(catchError((error) => handleError(error)));
};
